import map from 'lodash/map'
import React, { FC, useMemo } from 'react'

import { PageGrid, PageGridProps } from '@Components/CMS/PageGrid'
import {
  Page as GraphQLPage,
  PageGridBlock as GraphQLPageGridBlock,
  Position as GraphQLPosition,
} from '@Generated/graphql'

const getBlockData = (pageGridBlock: GraphQLPageGridBlock): PageGridProps => {
  const pages = (pageGridBlock.references as GraphQLPage[]) || []

  return {
    columns: pageGridBlock.columns || 2,
    items: map(pages, x => ({
      brand: x.brand
        ? {
          id: x.brand.id || '',
          logo: x.brand.logo || undefined,
          title: x.brand.title || '',
        }
        : undefined,
      description: x.openGraph?.description || '',
      id: x.id || '',
      image: x.openGraph?.imageURL || '',
      link: x.url || '',
      pageType: x.type || '',
      title: x.openGraph?.title || '',
    })),
    showDescription: pageGridBlock.showDescription || false,
    titlePosition: pageGridBlock.titlePosition === GraphQLPosition.Bottom ? 'bottom' : 'overlay',
  }
}

interface PageGridBlockProps {
  id?: string
  pageGridBlock: GraphQLPageGridBlock
}

const PageGridBlock: FC<PageGridBlockProps> = ({ id, pageGridBlock }) => {
  const blockProps = useMemo(() => getBlockData(pageGridBlock), [pageGridBlock])

  return (
    <PageGrid {...blockProps} id={id} />
  )
}

export default PageGridBlock
